var FieldType;
(function (FieldType) {
    FieldType["Checkboxes"] = "checkbox";
    FieldType["RadioButtons"] = "radio";
    FieldType["Slider"] = "slider";
})(FieldType || (FieldType = {}));
var Question = /** @class */ (function () {
    function Question(data) {
        this.data = data;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Question.prototype.isAsked = function (_sessionAnswers) {
        // TODO: Get real results
        return true;
    };
    Object.defineProperty(Question.prototype, "id", {
        get: function () {
            return Number(this.data.id);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Question.prototype, "title", {
        get: function () {
            return this.data.title;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Question.prototype, "description", {
        get: function () {
            return this.data.description;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Question.prototype, "subtitle", {
        get: function () {
            return this.data.subtitle;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Question.prototype, "startingQuestion", {
        get: function () {
            return this.data.starting_question === Question.BOOLEAN_STRING_VALUE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Question.prototype, "riskValue", {
        get: function () {
            return parseInt(this.data.risk_value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Question.prototype, "drugs", {
        get: function () {
            return this.data.drugs.split(Question.DRUG_SEPARATOR);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Question.prototype, "hasSubs", {
        get: function () {
            return this.data.hasSubs === 'Yes';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Question.prototype, "answers", {
        get: function () {
            return this.data.answers.toLowerCase().split(Question.ANSWERS_SEPARATOR);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Question.prototype, "dependencies", {
        get: function () {
            var dep = this.data.field_type === 'slider' ||
                this.data.field_type === 'checkbox' ||
                (this.data.field_type === '' && this.data.risk_value === '')
                ? this.data.dependencies.split(',')
                : this.data.dependencies.split(Question.DEPENDENCIES_ITEM_SEPARATOR);
            return dep.map(function (item) {
                var vals = item.split(Question.DEPENDENCIES_VALUE_SEPARATOR);
                var dependency = {
                    id: vals[0],
                    value: vals[1],
                };
                return dependency;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Question.prototype, "fieldType", {
        get: function () {
            var fieldType = this.data.field_type || '';
            if (fieldType.trim().length === 0) {
                return FieldType.RadioButtons;
            }
            return fieldType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Question.prototype, "url", {
        get: function () {
            return this.data.title
                .toString()
                .toLowerCase()
                .replace(/\s+/g, '-') // Replace spaces with -
                .replace(/[^\w\-]+/g, '') // Remove all non-word chars
                .replace(/\-\-+/g, '-') // Replace multiple - with single -
                .replace(/^-+/, '') // Trim - from start of text
                .replace(/-+$/, '');
        },
        enumerable: false,
        configurable: true
    });
    // Separator for different values for drug data
    Question.DRUG_SEPARATOR = '||';
    // Value used to denote a true value in data
    Question.BOOLEAN_STRING_VALUE = '1';
    // Separator for different values for answers
    Question.ANSWERS_SEPARATOR = '||';
    // Separator for different dependency tests
    Question.DEPENDENCIES_ITEM_SEPARATOR = '||';
    // Separator for dependency IDs and values
    Question.DEPENDENCIES_VALUE_SEPARATOR = '|';
    return Question;
}());
export default Question;
